
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.79 4.79a.422.422 0 01.299-.123h15.644a.422.422 0 01.422.422v4.267a1 1 0 102 0V5.089a2.422 2.422 0 00-2.422-2.422H5.09a2.422 2.422 0 00-2.423 2.422v11.378a2.422 2.422 0 002.423 2.422h1.844v3.267a1 1 0 001.6.8l2.845-2.134a1 1 0 00-1.2-1.6l-1.245.933V17.89a1 1 0 00-1-1H5.09a.422.422 0 01-.423-.422V5.089c0-.112.045-.22.124-.299zm3.143 2.143a1 1 0 100 2h9.956a1 1 0 100-2H7.933zm-1 5.267a1 1 0 011-1h2.845a1 1 0 110 2H7.933a1 1 0 01-1-1zm6.69-1a1 1 0 00-1 1v8.533a1 1 0 001 1h3.851l3.974 3.974A1 1 0 0023.155 25v-3.267H25a1 1 0 001-1V12.2a1 1 0 00-1-1H13.622zm1 8.533V13.2H24v6.533h-1.845a1 1 0 00-1 1v1.853l-2.56-2.56a1 1 0 00-.706-.293h-3.267zm.844-4.689a1 1 0 011-1h5.688a1 1 0 110 2h-5.689a1 1 0 01-1-1zm1 1.845a1 1 0 000 2h5.688a1 1 0 100-2h-5.689z"}})])
          )
        }
      }
    